<template>
  <div class="search">
    <div class="field field--flat">
      <input
        type="search"
        id="search-input"
        class="field__input field__input--text"
        :class="{ 'field__input--filled': searchValue.length }"
        v-model="searchValue"
        @change="submitSearch"
      />
      <label for="search-input" class="field__label">{{
        $t('filter.search')
      }}</label>
      <span class="field__icon" @click="submitSearch">
        <i class="fas fa-search"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sortKey: {
      type: String,
      default: 'client',
    },
  },

  data() {
    return {
      searchValue: '',
    };
  },

  methods: {
    submitSearch() {
      this.$emit('update-search-value', {
        sortKey: this.sortKey,
        value: this.searchValue,
      });
    },
  },
};
</script>
